// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable jsx-a11y/label-has-for, react/destructuring-assignment */
import * as React from "react"
import classnames from "classnames"
import Check from "@kiwicom/orbit-components/lib/icons/Check"

import spFieldWrapper from "../spFieldWrapper/spFieldWrapper"
import Translate from "../../../../app/scripts/components/Translate"
import type { SpFieldFunc } from "../spFieldWrapper/spFieldWrapper"

type Props = {
  bordered?: boolean
  // @ts-expect-error: Flow to TS migration.
  checked?: boolean
  classList?: string // confusing string not array,
  error?: string
  middle?: boolean
  showErrorNote?: boolean
  // @ts-expect-error: Flow to TS migration.
  checked?: boolean
  touched: boolean
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  valueLink?: any
  spFieldFunc: SpFieldFunc
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: any
  children: React.ReactNode
  name: string
}

const extractAriaProps = (props: Props) => ({
  // @ts-expect-error: Flow to TS migration.
  "aria-labelledby": props["aria-labelledby"],
  // @ts-expect-error: Flow to TS migration.
  id: props.checkBoxID,
})

const CheckBoxField = (props: Props) => {
  const {
    bordered = true,
    classList,
    error,
    middle,
    showErrorNote,
    touched,
    valueLink,
    spFieldFunc,
    name,
  } = props
  const hasError = touched && error

  return (
    <div
      className={classnames(
        "CheckBoxField spField",
        spFieldFunc.getClasses(),
        { _bordered: bordered, _error: hasError, _middle: middle },
        classList,
      )}
    >
      <label className="CheckBoxField-wrapper">
        <div className="CheckBoxField-checkbox">
          <input
            className="spCheckbox"
            type="checkbox"
            onChange={props.onChange}
            name={name}
            // Initially can be undefined => react uncontrolled element warning
            // Fix this the next time the file is edited. (Flow to TS)
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            checked={props.checked || false}
            {...extractAriaProps(props)}
          />
          {props.checked ? <Check ariaHidden size="small" className="spCheckbox-icon" /> : null}
        </div>
        <div className="CheckBoxField-label" data-test="CheckBoxField-label">
          <span>{props.children}</span>
        </div>
      </label>

      {valueLink
        ? spFieldFunc.renderError()
        : hasError &&
          showErrorNote && (
            <div className="spField-error">
              <span className="spField-note spTypo-note">
                <Translate tKey={error} />
              </span>
            </div>
          )}
    </div>
  )
}

export default spFieldWrapper(CheckBoxField)
